/**
 * Default Docket Entries Tab
 */

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const LegalCasePartySliderSettingsState = {
  legalCasePartySliderSettings: {},
  legalCasePartySliderSettingsLoading: false,
}

export const LegalCasePartySliderSettingsActions = {
  createLegalCasePartySliderSettings: async ({ commit }, value) => {
    commit('setLegalCasePartySliderSettingsLoading', true)

    return axiosRequest.
      post('/admin/site_settings', {
        name: 'legal_case_party_slider',
        value,
      }).
      then(({ data }) => {
        commit('setLegalCasePartySliderSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setLegalCasePartySliderSettingsLoading', false))
  },

  getLegalCasePartySliderSettings: async ({ commit }) => {
    commit('setLegalCasePartySliderSettingsLoading', true)

    return axiosRequest.
      get('/admin/site_settings/legal_case_party_slider').
      then(({ data }) => {
        commit('setLegalCasePartySliderSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setLegalCasePartySliderSettingsLoading', false))
  },

  updateLegalCasePartySliderSettings: async ({ getters, commit }, value) => {
    commit('setLegalCasePartySliderSettingsLoading', true)

    return axiosRequest.
      put(`/admin/site_settings/${getters.legalCasePartySliderSettingsId}`, {
        name: 'legal_case_party_slider',
        value,
      }).
      then(({ data }) => {
        commit('setLegalCasePartySliderSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setLegalCasePartySliderSettingsLoading', false))
  },

  deleteLegalCasePartySliderSettings: async ({ getters, commit }) => {
    commit('setLegalCasePartySliderSettingsLoading', true)

    return axiosRequest.
      delete(`/admin/site_settings/${getters.legalCasePartySliderSettingsId}`).
      then(({ data }) => {
        commit('setLegalCasePartySliderSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setLegalCasePartySliderSettingsLoading', false))
  },
}

export const LegalCasePartySliderSettingsMutations = {
  setLegalCasePartySliderSettings: (state, payload) => { state.legalCasePartySliderSettings = payload },
  setLegalCasePartySliderSettingsLoading: (state, payload) => { state.legalCasePartySliderSettingsLoading = payload },
  setLegalCasePartySliderSettingsValue: (state, payload) => { state.legalCasePartySliderSettings.value = payload },
}

export const LegalCasePartySliderSettingsGetters = {
  legalCasePartySliderSettings: state => state.legalCasePartySliderSettings,
  legalCasePartySliderSettingsId: state => state.legalCasePartySliderSettings?.id,
  legalCasePartySliderSettingsLoading: state => state.legalCasePartySliderSettingsLoading,
  legalCasePartySliderSettingsValue: state => state.legalCasePartySliderSettings?.value,
}
